import { render, staticRenderFns } from "./commission.vue?vue&type=template&id=2421a38b&scoped=true&"
import script from "./commission.vue?vue&type=script&lang=js&"
export * from "./commission.vue?vue&type=script&lang=js&"
import style0 from "./commission.vue?vue&type=style&index=0&id=2421a38b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2421a38b",
  null
  
)

export default component.exports